<app-header [sub_titulo]="editando? 'Editando destinatario' : 'Nuevo destinatario'" path="/config/destinatarios"></app-header>
<!-- Panel izquierda -->
<mat-card style="background-color: #f8f8ff; width: 100%; height: auto">
    <div id="menus" style="min-height: 95vh; height: auto">
        <div class="card-body-content" style="width: 99%; min-height: 90%; max-height: 99%; height: 90%">
            <br />
            <mat-card style="height: 99%">
                <div class="nuevo-asistente-container">
                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Código (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="codigo">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Título (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="titulo">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Descripción (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="descripcion">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-campo-default-admin descripcion_etiqueta="Destinatario (*)"
                            placeholder_input="Este campo es obligatorio" [(ngModel)]="target">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group">
                        <app-generic-select [options]="opcionesTipo" placeholder="Tipo (*)" [(ngModel)]="targetType">
                        </app-generic-select>
                    </div>

                    <div class="form-group" *ngIf="targetType=='Workgroup'">
                        <app-campo-default-admin descripcion_etiqueta="Horario inicio (*)"
                            placeholder_input="Horario inicio" [(ngModel)]="horaInicio"
                            (blurEmitter)="asegurarFormatoHoraInicio()">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-group" *ngIf="targetType=='Workgroup'">
                        <app-campo-default-admin descripcion_etiqueta="Horario fin (*)" placeholder_input="Horario fin"
                            [(ngModel)]="horaFin" (blurEmitter)="asegurarFormatoHoraFin()">
                        </app-campo-default-admin>
                    </div>

                    <div class="form-field-align" *ngIf="this.editando">
                        <label for="habilitado">Habilitado (*)</label>
                        <mat-slide-toggle [(ngModel)]="habilitado"></mat-slide-toggle>
                    </div>

                    <app-mensaje-error *ngIf="error" [mensaje_error]="error"></app-mensaje-error>
                    <div class="fin">
                        <app-boton-primario [disabled]="loading" [spinner]="loading"
                            [boton_texto]="loading ? 'Guardando' : 'Guardar'"
                            (boton_funcion)="applyOperation()"></app-boton-primario>
                        <button mat-raised-button  (click)="volver()">Cancelar</button>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</mat-card>